module.exports = __webpack_public_path__ + "static/media/fortress10.07b37cfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fortress10.jpg
// module id = 1022
// module chunks = 0